import type { DisplayUnits } from '../session/sceneUnits';

export const types = {
  RECEIVE_DISPLAY_UNITS: 'common/viewer/dxfViewer/RECEIVE_DISPLAY_UNITS',
  RECEIVE_SCENE_UNITS: 'common/viewer/dxfViewer/RECEIVE_SCENE_UNITS',
  RECEIVE_DIMENSIONAL_PRECISION:
    'common/viewer/dxfViewer/RECEIVE_DIMENSIONAL_PRECISION',
} as const;

export const displayOptions = {
  receiveDisplayUnits: ({ displayUnits }: { displayUnits: DisplayUnits }) => ({
    type: types.RECEIVE_DISPLAY_UNITS,
    payload: { displayUnits },
  }),
  /** The drawing's own unit, from its `$INSUNITS` header. Never a user choice. */
  receiveSceneUnits: ({
    displayUnits,
    isUnitless,
  }: {
    displayUnits: DisplayUnits | null;
    isUnitless: boolean;
  }) => ({
    type: types.RECEIVE_SCENE_UNITS,
    payload: { displayUnits, isUnitless },
  }),
  receiveDimensionalPrecision: ({
    dimensionalPrecision,
  }: {
    dimensionalPrecision: number;
  }) => ({
    type: types.RECEIVE_DIMENSIONAL_PRECISION,
    payload: { dimensionalPrecision },
  }),
};
